/*
 * The JS mirror of the Tailwind `screens` config.
 *
 * Before this existed the app had three disagreeing sets of breakpoints —
 * 1250px in App.css, 1250/1279/1430/900/767/430px across useMediaQuery calls,
 * and Tailwind's 1280px `xl:` in 318 classNames. A component could believe it
 * was on a phone while its own CSS had already switched to the desktop layout.
 *
 * Keep these in sync with tailwind.config.js.
 */
export const BREAKPOINTS = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

/** True at or above the named breakpoint. */
export const above = (bp: Breakpoint) => ({ query: `(min-width: ${BREAKPOINTS[bp]}px)` });

/** True strictly below the named breakpoint. */
export const below = (bp: Breakpoint) => ({ query: `(max-width: ${BREAKPOINTS[bp] - 1}px)` });

/** `lg` is where the top nav becomes the side nav. */
export const DESKTOP_NAV = above('lg');
